import { useQuery } from '@tanstack/react-query'

import { getBookingBookmarks } from '@/features/auth'

export const useGetBookingBookmarks = (enabled: boolean = true) => {
  return useQuery({
    queryKey: ['getBookingBookmarks'],
    queryFn: getBookingBookmarks,
    select: (data) => data.owner,
    enabled: enabled,
  })
}
